<app-monaco-editor [options]="editorOptions"
                   (onInit)="onEditorInit($event)"
                   lightTheme="datex-inline-expr"
                   darkTheme="datex-inline-expr-dark"></app-monaco-editor>